import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock,
    BlockType,
    SettingType,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export default class Tibbit_41 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_41';
        this.name = 'Tibbit 41';

        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];

        const settings = [
            {
                id: 'PORT_NAME',
                name: '8-bit Port Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.WORD,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);

        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt41/tbt41.tbh',
            'libraries/tibbits/tbt41/tbt41.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const connectedSocket = (Number(this.getSettingValue('SOCKET')) - 1).toString();
        const NAME = this.getSettingValue('PORT_NAME');

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
'Tibbit 41 setup on socket ${connectedSocket}
'================================================================
select case tbt41_init("${NAME}", YES,${NAME}_CLK,${NAME}_DATA,${NAME}_CHANNEL)
case TBT41_SELF_TEST_FAIL:
    sys.debugprint("TBT41 self test failed!\\r\\n")
    sys.halt()

case TBT41_NO_SSI_AVAILABLE:
    sys.debugprint("SSI channel could not be allocated, using bit banging instead.\\r\\n")
end select

'-----------------------------------------------------------------
                `,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${NAME}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${NAME}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${NAME}_CLK = ${Tibbits.getSocketPins(connectedSocket, this.project.device.id)[0]}
const ${NAME}_DATA = ${Tibbits.getSocketPins(connectedSocket, this.project.device.id)[1]}`,
        });

        return blocks;
    }
}
